import React from "react"

const FeesPlastics = props => {
  return (
    //   <div style={{ textAlign: "left" }}>
    //     <span className="text-dark d-block my-4 font-weight-bold">FREE</span>
    //     <ul className="doc-list mt-0" style={{ textAlign: "center" }}>
    //       <li className="my-1">
    //         <div>
    //           {/* <span>Application Fee for Individual Motor Authorization</span>:
    //           <strong>10,000</strong>
    //           <span>RWF</span> */}
    //         </div>
    //       </li>
    //     </ul>
    //     {/* <div>
    //       <span className=" text-dark d-block my-4 font-weight-bold">
    //         Renewal:
    //       </span>
    //       <ul className="doc-list mt-0">
    //         <li className="my-1">
    //           <div>
    //             <span>Application Fee for Individual Motor Authorization</span>:
    //             <strong>10,000</strong>
    //             <span>RWF</span>
    //           </div>
    //         </li>
    //         <li className="my-1">
    //           <div>
    //             <span>Authorization Fee for Individual Motorcyclists</span>:
    //             <strong>10,000</strong>
    //             <span>RWF</span>
    //           </div>
    //         </li>
    //       </ul>
    //     </div> */}
    //   </div>

    <div className="text-dark d-block my-4 font-weight-bold">FREE</div>
  )
}

export default FeesPlastics
